<div cdkTrapFocus>
  <div class="modal-header">
    <h3 class="modal-title">
      <span i18n="faretypeHeader">Flight Fare Details</span>: {{ from }}
      <i class="ico ico-breadcrumb-arrow"></i> {{ to }}
    </h3>
    <button
      type="button"
      class="close"
      aria-label="Flight Fare Details Close"
      ngbAutoFocus
      (click)="activeModal.close(true)"
    >
      <span aria-hidden="true"><i class="ico-cancel modal_exit_cross"></i></span>
    </button>
  </div>
  <div class="modal-body">
    <div class="fare-rules-warning" i18n="faretypeWarning" i18n="@@fareDetailsPleaseNote">
      Please Note: When booking a return journey the most restrictive fare rules will apply for the
      whole itinerary.
    </div>
    @if (!inboundRules) {
      <div class="fare-rules-container">
        @if (flight?.outboundFlights) {
          <div class="segment-block">
            @for (segment of flight.outboundFlights; track segment) {
              <div
                class="segment-block-segment"
                [ngClass]="{ 'selected-segment': segment.id === selectedId }"
                (click)="selectSegment(segment)"
                (keydown.enter)="selectSegment(segment)"
                (keydown.space)="selectSegment(segment)"
                tabindex="0"
                role="button"
              >
                <div class="left-title">
                  <span class="direction-span" i18n="fareDetailsDepart">Depart</span>
                  @if (segment.marketingCarrier !== '9F') {
                    <img
                      class="logo"
                      src="https://images.sabscorp.com/images/TourOp/svg/{{
                        segment.marketingCarrier
                      }}.svg"
                      alt="{{ segment.marketingCarrierName }}"
                    />
                  }
                  @if (segment.marketingCarrier === '9F') {
                    <img
                      class="logo"
                      src="https://images.sabscorp.com/images/enterprise/scion/assets/svg/eurostar.svg"
                      alt="Eurostar"
                    />
                  }
                </div>
                <div class="segment-block-info">
                  <span class="date-span">{{
                    segment.dateTimeDeparting | date: 'EEE dd MMM'
                  }}</span>
                  <div class="thirds-container">
                    <div class="thirds-block">
                      <h5>
                        <b>{{ segment.dateTimeDeparting | date: 'HH:mm' }}</b
                        ><br />
                        {{ segment.originAirport }}
                      </h5>
                    </div>
                    <div class="thirds-block">
                      <img
                        class="segment-arrow"
                        alt=""
                        src="https://images.sabscorp.com/images/enterprise/scion/assets/png/tab_arrow.png"
                      />
                      <span class="visuallyhidden">Arrival:</span>
                    </div>
                    <div class="thirds-block">
                      <h5>
                        <b>{{ segment.dateTimeArriving | date: 'HH:mm' }}</b
                        ><br />
                        {{ segment.destinationAirport }}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        }
        @if (!loading && rules) {
          <div class="content-block">
            @if (rules.cancellation && rules.cancellation.length > 0) {
              <div>
                <h4 i18n="@@fareruleCancellation">Cancellation</h4>
                <app-farerule-items [items]="rules.cancellation"></app-farerule-items>
              </div>
            }
            @if (rules.change && rules.change.length > 0) {
              <div>
                <h4 i18n="@@fareruleChanges">Changes</h4>
                <app-farerule-items [items]="rules.change"></app-farerule-items>
              </div>
            }
            @if (rules.noShow && rules.noShow.length > 0) {
              <div>
                <h4 i18n="@@fareruleNoShow">No Show</h4>
                <app-farerule-items [items]="rules.noShow"></app-farerule-items>
              </div>
            }
            @if (rules.upgrade && rules.upgrade.length > 0) {
              <div>
                <h4 i18n="@@fareruleUpgrading">Upgrading</h4>
                <app-farerule-items [items]="rules.upgrade"></app-farerule-items>
              </div>
            }
            @if (rules.other && rules.other.length > 0) {
              <div>
                <h4 i18n="@@fareruleOther">Other</h4>
                <app-farerule-items [items]="rules.other"></app-farerule-items>
              </div>
            }
          </div>
        }
        @if (!loading && !rules) {
          <div class="content-block">
            <span class="error" i18n="@@noRulesError">No Rules Found.</span>
          </div>
        }
        @if (loading) {
          <div i18n="@@LoadingFareRules">Loading Fare Rules...</div>
        }
      </div>
    }
    @if (inboundRules) {
      <div class="fare-rules-container return-container">
        <div class="flex-row-container">
          @if (flight?.outboundFlights) {
            <div class="flex-column-container flight-container outbound-flight">
              <div class="segment-block-segment">
                <div class="left-title">
                  @if (flight?.outboundFlights[0].marketingCarrier !== '9F') {
                    <img
                      class="logo"
                      src="https://images.sabscorp.com/images/TourOp/svg/{{
                        flight?.outboundFlights[0].marketingCarrier
                      }}.svg"
                      alt="{{ flight?.outboundFlights[0].marketingCarrierName }}"
                    />
                  }
                  @if (flight?.outboundFlights[0].marketingCarrier === '9F') {
                    <img
                      class="logo"
                      src="https://images.sabscorp.com/images/enterprise/scion/assets/svg/eurostar.svg"
                      alt="Eurostar"
                    />
                  }
                </div>
                <div class="segment-block-info">
                  <div class="thirds-container">
                    <div class="thirds-block">
                      <span class="date-span">{{
                        flight?.outboundFlights[0].dateTimeDeparting | date: 'EEE dd MMM'
                      }}</span>
                      <span class="airport_name">{{
                        flight?.outboundFlights[0].originAirportName
                      }}</span>
                      <div class="flex-row-container">
                        <span class="direction-span" i18n="fareDetailsDepart">Depart</span>&nbsp;
                        <b>{{ flight?.outboundFlights[0].dateTimeDeparting | date: 'HH:mm' }}</b>
                      </div>
                    </div>
                    <div class="thirds-block">
                      <img
                        class="segment-arrow"
                        alt=""
                        src="https://images.sabscorp.com/images/enterprise/scion/assets/png/tab_arrow.png"
                      />
                    </div>
                    <div class="thirds-block">
                      <span class="airport_name">{{
                        flight?.outboundFlights[flight.outboundFlights.length - 1]
                          .destinationAirportName
                      }}</span>
                      <b>{{
                        flight?.outboundFlights[flight.outboundFlights.length - 1].dateTimeArriving
                          | date: 'HH:mm'
                      }}</b>
                    </div>
                  </div>
                </div>
              </div>
              @if (!loading && rules) {
                <div class="content-block">
                  @if (rules.cancellation && rules.cancellation.length > 0) {
                    <div>
                      <h4 i18n="@@fareruleCancellation">Cancellation</h4>
                      <app-farerule-items [items]="rules.cancellation"></app-farerule-items>
                    </div>
                  }
                  @if (rules.change && rules.change.length > 0) {
                    <div>
                      <h4 i18n="@@fareruleChanges">Changes</h4>
                      <app-farerule-items [items]="rules.change"></app-farerule-items>
                    </div>
                  }
                  @if (rules.noShow && rules.noShow.length > 0) {
                    <div>
                      <h4 i18n="@@fareruleNoShow">No Show</h4>
                      <app-farerule-items [items]="rules.noShow"></app-farerule-items>
                    </div>
                  }
                  @if (rules.upgrade && rules.upgrade.length > 0) {
                    <div>
                      <h4 i18n="@@fareruleUpgrading">Upgrading</h4>
                      <app-farerule-items [items]="rules.upgrade"></app-farerule-items>
                    </div>
                  }
                  @if (rules.other && rules.other.length > 0) {
                    <div>
                      <h4 i18n="@@fareruleOther">Other</h4>
                      <app-farerule-items [items]="rules.other"></app-farerule-items>
                    </div>
                  }
                </div>
              }
              @if (!loading && !rules) {
                <div class="content-block">
                  <span class="error" i18n="@@noRulesError">No Rules Found.</span>
                </div>
              }
              @if (loading) {
                <div i18n="@@LoadingFareRules">Loading Fare Rules...</div>
              }
            </div>
          }
          @if (flight?.inboundFlights) {
            <div class="flex-column-container flight-container">
              <div class="segment-block-segment">
                <div class="left-title">
                  @if (flight?.inboundFlights[0].marketingCarrier !== '9F') {
                    <img
                      class="logo"
                      src="https://images.sabscorp.com/images/TourOp/svg/{{
                        flight?.inboundFlights[0].marketingCarrier
                      }}.svg"
                      alt="{{ flight?.inboundFlights[0].marketingCarrierName }}"
                    />
                  }
                  @if (flight?.inboundFlights[0].marketingCarrier === '9F') {
                    <img
                      class="logo"
                      src="https://images.sabscorp.com/images/enterprise/scion/assets/svg/eurostar.svg"
                      alt="Eurostar"
                    />
                  }
                </div>
                <div class="segment-block-info">
                  <div class="thirds-container">
                    <div class="thirds-block">
                      <span class="date-span">{{
                        flight?.inboundFlights[0].dateTimeDeparting | date: 'EEE dd MMM'
                      }}</span>
                      <span class="airport_name">{{
                        flight?.inboundFlights[0].originAirportName
                      }}</span>
                      <div class="flex-row-container">
                        <span class="direction-span" i18n="fareDetailsReturn">Return</span>&nbsp;
                        <b>{{ flight?.inboundFlights[0].dateTimeDeparting | date: 'HH:mm' }}</b>
                      </div>
                    </div>
                    <div class="thirds-block">
                      <img
                        class="segment-arrow"
                        alt=""
                        src="https://images.sabscorp.com/images/enterprise/scion/assets/png/tab_arrow.png"
                      />
                    </div>
                    <div class="thirds-block">
                      <span class="airport_name">{{
                        flight?.inboundFlights[flight.inboundFlights.length - 1]
                          .destinationAirportName
                      }}</span>
                      <b>{{
                        flight?.inboundFlights[flight.inboundFlights.length - 1].dateTimeArriving
                          | date: 'HH:mm'
                      }}</b>
                    </div>
                  </div>
                </div>
              </div>
              @if (!loading && inboundRules) {
                <div class="content-block">
                  @if (inboundRules.cancellation && inboundRules.cancellation.length > 0) {
                    <div>
                      <h4 i18n="@@fareruleCancellation">Cancellation</h4>
                      <app-farerule-items [items]="inboundRules.cancellation"></app-farerule-items>
                    </div>
                  }
                  @if (inboundRules.change && inboundRules.change.length > 0) {
                    <div>
                      <h4 i18n="@@fareruleChanges">Changes</h4>
                      <app-farerule-items [items]="inboundRules.change"></app-farerule-items>
                    </div>
                  }
                  @if (inboundRules.noShow && inboundRules.noShow.length > 0) {
                    <div>
                      <h4 i18n="@@fareruleNoShow">No Show</h4>
                      <app-farerule-items [items]="inboundRules.noShow"></app-farerule-items>
                    </div>
                  }
                  @if (inboundRules.upgrade && inboundRules.upgrade.length > 0) {
                    <div>
                      <h4 i18n="@@fareruleUpgrading">Upgrading</h4>
                      <app-farerule-items [items]="inboundRules.upgrade"></app-farerule-items>
                    </div>
                  }
                  @if (inboundRules.other && inboundRules.other.length > 0) {
                    <div>
                      <h4 i18n="@@fareruleOther">Other</h4>
                      <app-farerule-items [items]="inboundRules.other"></app-farerule-items>
                    </div>
                  }
                </div>
              }
              @if (!loading && !inboundRules) {
                <div class="content-block">
                  <span class="error" i18n="@@noRulesError">No Rules Found.</span>
                </div>
              }
              @if (loading) {
                <div i18n="@@LoadingFareRules">Loading Fare Rules...</div>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>
  <div class="modal-footer">
    @if (fareRulesKey) {
      <div class="fare_rule-key">
        @if (fareRulesKey.isCHA) {
          <span i18n="@@fareruleCHA"> CHA = Chargeable</span>
        }
        @if (fareRulesKey.isINC) {
          <span i18n="@@fareruleINC"> INC = Included</span>
        }
        @if (fareRulesKey.isNOF) {
          <span i18n="@@fareruleNOF"> NOF = Not Offered</span>
        }
      </div>
    }
    <button
      type="button"
      appButton="small"
      class="small-button--no"
      i18n="@@fareruleOK"
      (click)="activeModal.close(false)"
    >
      Ok
    </button>
  </div>
</div>
